/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
// import JoditEditor from "jodit-react";
import React, {
  useCallback,
  useState,
  useEffect,
  useContext,
  // useMemo,
} from "react";
import { useDropzone } from "react-dropzone";
import { Formik } from "formik";
// import { format } from "date-fns";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import * as Sentry from "@sentry/react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../components/common/Button";
import Typography from "../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import style from "./CreateTicket.style";
import Loader from "../../../components/common/Loader/Loader";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
// import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
// import DatePicker from "../DatePicker/DatePicker";
import TicketingSystem from "../../../services/api/ticketingSystem";
// import Member from "../../../services/api/member";
import {
  // selectUserProfile,
  selectUserRole,
} from "../../../redux/selectors/user";
// import { debounce } from "../../../utils/helper";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";

const PROJECT_OPTIONS = [
  {
    key: "Bds",
    value: "BDS",
  },
  {
    key: "Contribution",
    value: "CONTRIBUTION",
  },
];

// const MODULE_OPTIONS = [
//   {
//     key: "MEMBER_TRANSFER",
//     value: "MEMBER_TRANSFER",
//   },
// ];

const PRIORITY_OPTIONS = [
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardDoubleArrowUpIcon style={{ color: "red" }} /> Highest
      </Box>
    ),
    value: "HIGHEST",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardArrowUpIcon style={{ color: "red" }} /> High
      </Box>
    ),
    value: "HIGH",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <DragHandleIcon style={{ color: "rgb(250 215 24)" }} /> Medium
      </Box>
    ),
    value: "MEDIUM",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardArrowDownIcon style={{ color: "#0052cc" }} /> Low
      </Box>
    ),
    value: "LOW",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardDoubleArrowDownIcon style={{ color: "#0052cc" }} /> Lowest
      </Box>
    ),
    value: "LOWEST",
  },
];

// const MAX_RESULT = 5;

// const getMemberOptions = (members) =>
//   members.length
//     ? members.map((member) => ({
//         displayName: `${member.fullName} - ${member.memberId}`,
//         value: member.memberId,
//       }))
//     : [];

function CreateTicket() {
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [selectedReporter, setSelectedReporter] = useState(null);
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState("");
  // const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [selectedAppointmentDate, setSelectedAppointmentDate] = useState("");
  // new Date()
  // const user = useSelector(selectUserProfile);
  const userRole = useSelector(selectUserRole);
  const toast = useContext(ToastAlertContext);

  // const REPORTER_OPTIONS = [
  //   {
  //     key: user.fullName,
  //     value: user.memberId,
  //   },
  // ];

  // const onSearchMember = async (search) => {
  //   const abortSearch = options?.find((m) => m.displayName === search);

  //   if (abortSearch || !search) return;

  //   try {
  //     const formattedQuery = {
  //       memberId: Number(search),
  //     };
  //     const params = {
  //       pageSize: MAX_RESULT,
  //     };
  //     setLoading(true);
  //     const { data } = await Member.search(formattedQuery, params, false);
  //     setOptions(getMemberOptions(data.content));
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     Sentry.captureException(error);
  //   }
  // };

  // const onDateSelect = (appointedAt) => {
  //   setSelectedAppointmentDate(new Date(appointedAt));
  // };

  const [files, setFiles] = useState([]);

  const validateCreateTicket = () => {
    if (!selectedProject) {
      toast.show("Please Select Project", AlertStatus.ERROR);
      return false;
    }
    if (!selectedModule) {
      toast.show("Please Select Module", AlertStatus.ERROR);
      return false;
    }
    if (!subject) {
      toast.show("Please Select Subject", AlertStatus.ERROR);
      return false;
    }
    return true;
  };

  const handleAttachments = async (file) => {
    const allowedFileTypes = [
      "application/msword",
      "application/vnd.ms-excel",
      "application/pdf",
      "text/plain",
      "text/csv",
      "application/xml",
      "text/xml",
      "image/png",
      "image/webp",
      "image/jpeg",
      "application/zip",
      "application/gzip",
      "application/x-zip-compressed",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/x-7z-compressed",
      "application/vnd.google-apps.document",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.google-apps.kix",
      "application/vnd.google-apps.form",
      "application/vnd.google-apps.presentation",
      "application/vnd.google-apps.spreadsheet",
    ];

    if (file) {
      if (!allowedFileTypes.includes(file.type)) {
        toast.show("Selected file format is not supported", AlertStatus.ERROR);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await TicketingSystem.uploadAttachments({
          data: formData,
        });
        if (response.code === 200) {
          const { data } = response;
          setFiles((prevAttachmentsData) => [...prevAttachmentsData, data]);
          toast.show("File Attached Successfully", AlertStatus.SUCCESS);
        }
      } catch (error) {
        toast.show(
          "Error uploading file. Please try again.",
          AlertStatus.ERROR
        );
      }
    } else {
      toast.show("No file selected.", AlertStatus.ERROR);
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      handleAttachments(file);
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });

  const handleRemoveAttachment = (attachmentIndex, attachmentId) => {
    setFiles((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== attachmentIndex)
    );
    setFiles((prevAttachments) =>
      prevAttachments.filter((ide) => ide !== attachmentId)
    );
  };

  const [moduleNameOptions, setModuleNameOptions] = useState([]);

  const getModuleNames = async () => {
    const response = await TicketingSystem.getModuleName();
    setModuleNameOptions(response.data);
  };

  useEffect(() => {
    getModuleNames();
  }, []);

  const formatKey = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(" ");
  };

  const MODULE_OPTIONS = moduleNameOptions.map((option) => ({
    key: formatKey(option),
    value: option.toUpperCase(),
  }));

  const [assigneeNameOptions, setAssigneeNameOptions] = useState([]);

  const getAssigneeNames = async () => {
    const response = await TicketingSystem.getTicketAssignee();
    setAssigneeNameOptions(response.data);
  };

  useEffect(() => {
    getAssigneeNames();
  }, []);

  const ASSIGNEE_OPTIONS = assigneeNameOptions.map((option) => ({
    key: option.fullName,
    value: option.memberId,
  }));

  const resetForm = () => {
    setSelectedProject("");
    setSelectedModule("");
    setSelectedPriority("");
    setSelectedAssignee("");
    setSelectedReporter("");
    setDescription("");
    setSubject("");
    // setOptions([]);
    setFiles([]);
    // setSelectedAppointmentDate(new Date());
  };

  const onFormSubmit = async () => {
    if (!validateCreateTicket()) {
      return;
    }
    try {
      setLoading(true);
      const fileIds = files.map((file) => file.id);
      const payload = {
        projectType: selectedProject,
        moduleName: selectedModule,
        subject: subject,
        priority: selectedPriority,
        description: description,
        assigneeId: selectedAssignee,
        reporterId: selectedReporter,
        // dueDate: format(selectedAppointmentDate, "yyyy-MM-dd"),
        fileIds,
      };

      await TicketingSystem.createTicket(payload);
      toast.show("Ticket Created Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        resetForm();
        setLoading(false);
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
      setLoading(false);
    }
  };

  const handleProjectChange = (event) => {
    setSelectedProject(event.target.value);
  };

  const handleClearProject = () => {
    setSelectedProject("");
  };

  const handleModuleChange = (event) => {
    setSelectedModule(event.target.value);
  };

  const handleClearModule = () => {
    setSelectedModule("");
  };

  const handlePriorityChange = (event) => {
    setSelectedPriority(event.target.value);
  };

  const handleClearPriority = () => {
    setSelectedPriority("");
  };

  // const handleReporterChange = (event) => {
  //   setSelectedReporter(event.target.value);
  // };

  // const handleClearReporter = () => {
  //   setSelectedReporter("");
  // };

  const handleAssigneeChange = (event) => {
    setSelectedAssignee(event.target.value);
  };

  const handleClearAssignee = () => {
    setSelectedAssignee("");
  };

  // const handleInputChange = useCallback(debounce(onSearchMember), [
  //   selectedAssignee,
  //   options,
  // ]);

  // useEffect(() => {
  //   return () => setOptions([]);
  // }, []);

  return (
    <Box>
      <Formik
        initialValues={{ subject: "", description: "" }}
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 20px",
                borderBottom: "1px solid #e0e0e0",
                background: "#fafafa",
                borderRadius: "10px 10px 0 0",
              }}
            >
              {/* Title */}
              <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
                Create New Ticket
              </Typography>
            </Box>
            <Box style={{ display: "flex" }}>
              <Box
                style={{
                  width: "100%",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      padding: "20px 0px",
                    }}
                  >
                    <Typography style={style.typographyStyle}>
                      Required field are marked with an asterisk{" "}
                      <span style={style.spanStyle}>*</span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 4,
                      padding: "10px 0px",
                      flexWrap: "wrap", // mobile responsive
                    }}
                  >
                    {/* Project */}
                    <Box sx={{ flex: 1, minWidth: "250px" }}>
                      <Typography style={style.typographyStyle}>
                        Project <span style={style.spanStyle}>*</span>
                      </Typography>
                      <Box width="100%" paddingTop="10px">
                        <Dropdown
                          value={selectedProject}
                          options={PROJECT_OPTIONS}
                          label="Select"
                          onChange={handleProjectChange}
                          showCross
                          handleClearValue={handleClearProject}
                        />
                      </Box>
                    </Box>

                    {/* Module */}
                    <Box sx={{ flex: 1, minWidth: "250px" }}>
                      <Typography style={style.typographyStyle}>
                        Module <span style={style.spanStyle}>*</span>
                      </Typography>
                      <Box width="100%" paddingTop="10px">
                        <Dropdown
                          value={selectedModule}
                          options={MODULE_OPTIONS}
                          label="Select"
                          onChange={handleModuleChange}
                          showCross
                          handleClearValue={handleClearModule}
                        />
                      </Box>
                    </Box>
                  </Box>

                  {userRole === "helpDesk" && (
                    <Box sx={{ padding: "10px 0px" }}>
                      <Typography style={style.typographyStyle}>
                        Priority{" "}
                      </Typography>
                      <Box width="40%" paddingTop="10px">
                        <Dropdown
                          value={selectedPriority}
                          options={PRIORITY_OPTIONS}
                          label="Select"
                          onChange={handlePriorityChange}
                          showCross
                          handleClearValue={handleClearPriority}
                        />
                      </Box>
                    </Box>
                  )}
                  <Box sx={{ padding: "10px 0px" }}>
                    <Typography style={style.typographyStyle}>
                      Subject
                      {/* <span style={style.spanStyle}>*</span> */}
                    </Typography>
                    <Box width="90%" paddingTop="10px">
                      <InputField
                        name="subject"
                        label="Subject"
                        required
                        value={subject}
                        onChange={(e) => {
                          if (e.target.value.length <= 150) {
                            setSubject(e.target.value);
                          } else {
                            toast.show(
                              "Subject text length is limited to 150 characters only!",
                              AlertStatus.ERROR
                            );
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ padding: "10px 0px" }}>
                    <Typography style={style.typographyStyle}>
                      Description{" "}
                    </Typography>
                    <Box width="90%" paddingTop="10px">
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Start writing..."
                        multiline
                        maxRows={5}
                        rows={5}
                        style={style.textFieldStyle}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ padding: "10px 0px" }}>
                    <Typography style={style.typographyStyle}>
                      Attachment{" "}
                    </Typography>
                    <Box
                      {...getRootProps()}
                      sx={{
                        width: "75%",
                        height: "100px",
                        flexShrink: "0",
                        borderRadius: "3px",
                        border: "0.5px dashed #484848",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        backgroundColor: isDragActive ? "#f0f0f0" : "#fff",
                        transition: "background-color 0.2s",
                        paddingTop: "10px",
                      }}
                    >
                      <input {...getInputProps()} />
                      <FileUploadOutlinedIcon />
                      {isDragActive ? (
                        <Typography>Drag and Drop or Browse</Typography>
                      ) : (
                        <Typography>Drag and Drop or Browse</Typography>
                      )}
                    </Box>
                    <Box>
                      {files?.length > 0 && (
                        <div style={style.attachmentsLists}>
                          <ul>
                            {files?.map((attachment, index) => (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                }}
                              >
                                <li
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                  onChange={(e) => onDrop(e.target.files)}
                                >
                                  - {attachment?.originalFileName}
                                  <ClearIcon
                                    onClick={() =>
                                      handleRemoveAttachment(
                                        index,
                                        attachment?.id
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      )}
                    </Box>
                  </Box>
                  {userRole === "helpDesk" && (
                    <Box sx={{ padding: "10px 0px" }}>
                      <Typography style={style.typographyStyle}>
                        Assignee <span style={style.spanStyle}>*</span>
                      </Typography>
                      <Box width="40%" paddingTop="10px">
                        <Dropdown
                          value={selectedAssignee}
                          options={ASSIGNEE_OPTIONS}
                          label="Select assignee "
                          onChange={handleAssigneeChange}
                          showCross
                          handleClearValue={handleClearAssignee}
                        />
                        {/* <AutoCompleteDropdown
                        getOptionLabel={(option) => option.displayName}
                        label="Search Member ID"
                        name="searchMember"
                        options={options}
                        onChange={(selectedValue) => {
                          if (!selectedValue) {
                            setSelectedAssignee("");
                            setOptions([]);
                          } else {
                            setSelectedAssignee(selectedValue.value);
                          }
                        }}
                        onInputChange={handleInputChange}
                        value={selectedAssignee}
                        loading={loading}
                        filterSelectedOptions={false}
                        filterOptions={(x) => x}
                      /> */}
                      </Box>
                    </Box>
                  )}
                  {/* {Remove Reporter for Now} */}
                  {/* <Box sx={{ padding: "10px 0px" }}>
                    <Typography style={style.typographyStyle}>
                      Reporter <span style={style.spanStyle}>*</span>
                    </Typography>
                    <Box width="40%" paddingTop="10px">
                      <Dropdown
                        value={selectedReporter}
                        options={REPORTER_OPTIONS}
                        label="Select reporter"
                        onChange={handleReporterChange}
                        showCross
                        handleClearValue={handleClearReporter}
                      />
                    </Box>
                  </Box> */}
                  {/* {Remove Date for Now} */}
                  {/* <Box sx={{ padding: "10px 0px" }}>
                    <Typography style={style.typographyStyle}>
                      Due date <span style={style.spanStyle}>*</span>
                    </Typography>
                    <Box width="40%" paddingTop="10px">
                      <DatePicker
                        defaultValue={selectedAppointmentDate}
                        // disableFuture
                        onDateSelect={onDateSelect}
                      >
                        <Typography
                          weight={500}
                          variant="small"
                          style={style.dateStyle}
                        >
                          {selectedAppointmentDate
                            ? format(selectedAppointmentDate, "dd-MM-yyyy")
                            : "NA"}
                          <CalendarMonthOutlinedIcon
                            style={{ paddingLeft: "5px" }}
                          />
                        </Typography>
                      </DatePicker>
                    </Box>
                  </Box> */}
                </Box>
              </Box>
            </Box>
            <Box style={style.buttonStyle}>
              <Button
                style={CommonStyles.buttonStyle}
                variant="outlined"
                label="Cancel"
                onClick={resetForm}
              />
              <Button
                style={CommonStyles.buttonStyle}
                variant="contained"
                type="submit"
                label="Create"
              />
            </Box>
          </form>
        )}
      </Formik>
      {loading && <Loader />}
    </Box>
  );
}

export default CreateTicket;
